/**
 * A generator of route URLs
 */

const id = value => (value.id ? value.id : value);

export function pathWith(league, season, team) {
  return (name, model) => pathTo(name, league, season, team, model);
}

/**
 * @example
 * pathTo('team', leagueId, seasonId, teamId)
 */
export function pathTo(name, league, season, team, model) {
  if (name === 'teams') return '/teams';
  if (name === 'players') return '/players';
  if (name === 'player') return `/player/${id(league)}`;
  else if (!name || !season || !team) return '';

  const base = `/league/${id(league)}/season/${id(season)}/team/${id(team)}`;

  switch (name) {
    case 'team':
      return base;
    case 'games':
    case 'lineups':
    case 'onoff':
    case 'stats':
    case 'combinations':
      return `${base}/${name}`;
    case 'game-explorer':
    case 'lineup-explorer':
    case 'combination-explorer':
      return model ? `${base}/${name}/${id(model)}` : `${base}/${name}`;
    default:
      return '';
  }
}
